import { render, staticRenderFns } from "./IndexSizesPage.vue?vue&type=template&id=1ea50b0e&"
import script from "./IndexSizesPage.vue?vue&type=script&lang=js&"
export * from "./IndexSizesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports